export const INVALID_TOKEN_ERROR = "Invalid token.";
